import supabase from '@/supabaseClient'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export async function logFeatureUsage({
  feature,
  metadata,
}: {
  feature: string;
  metadata?: any;
}) {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session?.access_token) return // skip if not logged in
    await fetch(`${API_BASE_URL}/api/log-usage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ feature, metadata }),
    });
  } catch (err) {
    console.error('Failed to log feature usage to backend:', err);
  }
}